import { useQuery } from "@tanstack/react-query";
import { MonitorPlay } from "lucide-react";
import { useNavigate } from "react-router";
import { api } from "../api";
import { FlatTable } from "../components/flat-table";
import { EmptyState, PageHeader } from "../components/page";
import { CreatePreviewDialog } from "../components/previews/create-preview-dialog";
import { PreviewRow } from "../components/previews/preview-row";
import { Skeleton } from "../components/ui/skeleton";
import { TableBody, TableHead, TableHeader, TableRow } from "../components/ui/table";
import { useIsAdmin } from "../lib/permissions";

export function PreviewsPage() {
  const navigate = useNavigate();
  const admin = useIsAdmin();
  const query = useQuery({
    queryKey: ["previews"],
    queryFn: () => api.previews(),
    refetchInterval: 10_000,
  });
  const previews = query.data?.previews ?? [];

  return (
    <>
      <PageHeader
        title="Previews"
        description="Seeded, disposable copies of a pull request for business testing."
        actions={admin ? <CreatePreviewDialog /> : undefined}
      />
      {query.isLoading ? (
        <Skeleton className="h-48 w-full" />
      ) : previews.length === 0 ? (
        <EmptyState
          icon={MonitorPlay}
          title="No previews yet"
          description="The Verifier requests one when business testing needs it, or create one from an issue's Preview row."
        />
      ) : (
        <FlatTable>
          <TableHeader>
            <TableRow>
              <TableHead>Preview</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Pull request</TableHead>
              <TableHead>Head</TableHead>
              <TableHead>Expires</TableHead>
              <TableHead>Apps</TableHead>
              <TableHead className="w-24" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {previews.map((preview) => (
              <PreviewRow
                key={preview.id}
                preview={preview}
                onOpen={() => navigate(`/previews/${preview.id}`)}
              />
            ))}
          </TableBody>
        </FlatTable>
      )}
    </>
  );
}
